import { api } from "../lib/api";

/**
 * Update user's profile image
 */
export async function updateProfileImage(
	userId: string,
	imageUrl: string | null,
): Promise<{ success: boolean; userImage: string | null }> {
	const response = await api.post("/api/user/update-image", {
		userImage: imageUrl,
		userId,
	});
	return response.data;
}

/**
 * Save multiple profile fields at once
 */
export async function saveProfileFields(
	fields: Record<string, unknown>,
): Promise<{ success: boolean; savedFields: string[] }> {
	const response = await api.post("/api/user/save-onboarding-fields", {
		fields,
	});
	return response.data;
}

/**
 * Change user password (placeholder for now)
 */
export async function changePassword(
	currentPassword: string,
	newPassword: string,
): Promise<{ success: boolean }> {
	// TODO: Implement when backend endpoint is ready
	const response = await api.post("/api/user/change-password", {
		currentPassword,
		newPassword,
	});
	return response.data;
}

/**
 * Request account deletion
 */
export async function deleteAccount(): Promise<{
	success: boolean;
	message: string;
	deletionRequestedAt: string;
}> {
	const response = await api.post("/api/user/request-deletion");
	return response.data;
}
